import { Component, OnInit, ElementRef, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ConnectionPositionPair, Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var $: any;
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-report-view',
  templateUrl: './cnss-report-view.component.html',
  styleUrls: ['./cnss-report-view.component.scss']
})
export class CnssReportViewComponent implements OnInit {

  id: any;
  cnamgsId: any;
  page: any;
  public todayDate: any = new Date();
  response: any;
  cnssReport: any;
  cnamgsReport: any;
  purpose: any;
  employerDetails: any;
  cnamgsemployerDetails: any;
  reportAllList: any;
  cnamgsReportAllList: any;
  amount: any;
  cnamgsamount: any;
  redirectUrl: any;
  ref_id: any;
  penaltyRate: any;
  paymentPenaltyRate: any;
  cnamgspenaltyRate: any;
  cnamgspaymentPenaltyRate: any;
  penaltyParent: any;
  cnamgsPenaltyParent: any;
  showAllDtsList: boolean = false;
  showAllPaymentList: boolean = false;
  showAllCnamgsDtsList: boolean = false;
  showAllCnamgsPaymentList: boolean = false;

  isOpenCnamgsReport: boolean = true;
  isOpenCnssReport: boolean = true;
  @ViewChild('button', { static: true }) private buttonRef: ElementRef < HTMLButtonElement > ;

  @ViewChild(TemplateRef, { static: true }) private templateRef: TemplateRef < HTMLElement > ;
  amountToBePaidArray: any;
  amount_to_array: any;
  payment_array: any;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.page = this.router.getCurrentNavigation().extras.state.data;
      console.log("19", this.page)
    }
    this.ref_id = this.route.snapshot.queryParamMap.get('reference_id')
    console.log('this.ref_id', this.ref_id);
    
  }

  ngOnInit() {
    console.log("20", this.page)
    this.route.params.subscribe(
      (params: Params) => {
        console.log("36", params['id']);
        console.log("37", params);
        if (params['id'] != 'cnamgs') {
          this.id = params['id'];
          this.cnamgsId = params['cnamgsId'] || null;
          console.log("CNSS UUID:", this.id);
          console.log("CNAMGS UUID:", this.cnamgsId);
    
          // this.purpose = params['purpose'];
          this.getReportsbyID()

        } else {
          this.page = params['id'];
          console.log("114", this.page)
        }
      });
    // if (this.route.snapshot.paramMap.get('purpose')) {
    //   this.purpose = this.route.snapshot.paramMap.get('purpose');
    //   console.log("139", this.purpose)
    // }
  }

  editReport() {
    this.router.navigate(['cnss-reports', this.employerDetails.uuid, this.cnamgsemployerDetails.uuid]);
  }

  getReportsbyID() {
    this.ngxUiLoaderService.start();
    console.log("150", this.id)
    const data = {
      cnssuuid: this.id,
      cnamgsuuid: this.cnamgsId || null
    }
    this.api.getDtsReportsbyID(data).pipe(first())
      .subscribe(data => {
          this.response = data;
          this.ngxUiLoaderService.stop();
          if (this.response.status == 200) {
            this.employerDetails = this.response.results.cnss.data;
            console.log("157", this.employerDetails)
            console.log("158", this.employerDetails.status)
            this.cnssReport = this.response.results.cnss.quarter;
            this.reportAllList = this.response.results.cnss;
            this.amount = this.reportAllList.paid_to_cnss;
            this.penaltyRate = this.reportAllList.penalities.penalitiesMonthArray;
            this.paymentPenaltyRate = this.reportAllList.penalities.penalityPaymentArray;
            console.log(this.penaltyRate)

            if (this.employerDetails.status == 4) {
              this.router.navigate(['cnss-reports', this.id]);
            }


            // CNAMGS data assignment
            if (this.response.results.cnamgs) {
              this.cnamgsemployerDetails = this.response.results.cnamgs.data;
              console.log("CNAMGS Employer Details:", this.cnamgsemployerDetails)
              console.log("CNAMGS Status:", this.cnamgsemployerDetails.status)
              this.cnamgsReport = this.response.results.cnamgs.quarter;
              this.cnamgsReportAllList = this.response.results.cnamgs;
              this.cnamgsamount = this.cnamgsReportAllList.paid_to_cnamgs;
              this.cnamgspenaltyRate = this.cnamgsReportAllList.penalities.penalitiesMonthArray;
              this.cnamgspaymentPenaltyRate = this.cnamgsReportAllList.penalities.penalityPaymentArray;
              this.cnamgsPenaltyParent = this.response.results.cnamgs.penalities;
              console.log("CNAMGS Report:", this.cnamgsReport)
              console.log("CNAMGS Amount:", this.cnamgsamount)
              console.log("CNAMGS Penalty Rate:", this.cnamgspenaltyRate)
              if (this.cnamgsemployerDetails.status == 4) {
                this.router.navigate(['cnamgs-report', this.cnamgsId]);
              }
            }

            if (this.response.results.amount_to_be_paid_array) {
              this.amountToBePaidArray = this.response.results.amount_to_be_paid_array;
              console.log("200", this.amountToBePaidArray)
            }

            if (this.response.results.amount_to_array) {
              this.amount_to_array = this.response.results.amount_to_array;
              console.log("200", this.amount_to_array)
            }

            if (this.response.results.payment_array) {
              this.payment_array = this.response.results.payment_array;
              console.log("200", this.payment_array)
            }










           
            console.log("152", this.cnssReport)
            console.log("153", this.amount)
            console.log("154", this.employerDetails.employer_cnss)
            if (this.ref_id) {
              this.executePaymentDts()
            }
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  executePaymentDts() {
    var data = {};
    data['ref_id'] = this.ref_id;
    console.log("112", data)
    this.ngxUiLoaderService.start();
    this.api.paymetExecuteDts(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            //  this.processResponse(this.response);
            this.router.navigate(['/cnss-reportList'], { state: { payment_success: 1 } });
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 5000,
            });
          }
        },
        error => {});
  }

  executePayment() {
    var data = {};
    data['uuid'] = this.id;
    data['entity_type'] = '3';
    data['ref_id'] = this.ref_id;
    console.log("112", data)
    this.ngxUiLoaderService.start();
    this.api.paymetExecute(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            //  this.processResponse(this.response);
            this.router.navigate(['/cnss-reportList'], { state: { payment_success: 1 } });
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 5000,
            });
          }
        },
        error => {});
  }

  paymentSubmit() {
    this.router.navigate(['/payment/cnss'], { state: { report_id: this.id, amount: this.amount } });
  }
  showCnssList() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    $('#reportModal').modal('hide');
    this.id = 'normalcnss';
    // switch (this.id) {
    //   case 'normalcnss':
    //     {
    //       console.log('aa')
    //       $('.cnamgs_report').addClass('dNone');
    //       $('.payment_table').addClass('dNone');
    //       $('.dateTerminateInput').removeClass('dNone');
    //       $('.dateTerminate').removeClass('dBlock');

    //       $('.pendingStatus').removeClass('dBlock');
    //       $('.ongoingStatus').removeClass('dNone');
    //       $('.payNowStatus').addClass('dNone');
    //       $('.rejectedStatus').addClass('dNone');
    //       $('.completedStatus').addClass('dNone');

    //       $('input').removeClass('changeInput_style');
    //       $('.tableFooter').removeClass('dNone');
    //       $('#resubMit_btn').removeClass('d-block');
    //       $('#submit_btn').addClass('d-block');
    //       break;
    //     }
    // }

  }
  goToViewPage() {
    $('#successModal').modal('hide');

    this.router.navigate(['/cnss-reportList'], { state: { data: this.page } });
  }

  goback() {
    this.router.navigate(['/cnss-reportList'], { state: { data: this.page } });
  }

  paymentInitiate() {
    var data = {};
    data['uuid'] = this.id;
    data['entity_type'] = '3';
    data['total_amount'] = this.amount;
    data['return_url'] = window.location.href.split('?')[0];
    console.log("176", data)
    this.ngxUiLoaderService.start();
    this.api.paymentInitiate(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          console.log(this.response);
          
          if (this.response.status == 200) {
            this.redirectUrl = this.response.url;
            this.router.ngOnDestroy();
            window.location.href = this.redirectUrl;
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 4000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  ViewAllLateDtsList() {
    console.log("193")
    this.showAllDtsList = !this.showAllDtsList;
  }

  ViewAllLatepaymentList() {
    console.log("197")
    this.showAllPaymentList = !this.showAllPaymentList;
  }

  editCnamgsReport() {
    this.router.navigate(['cnamgs-report', this.cnamgsemployerDetails.uuid]);
  }


  paymentInitiateDts(cnss_uuid ?: any, cnamgs_uuid ?: any, paid_to_cnss ?: any, paid_to_cnamgs ?: any, total_combined ?: any) {




    var data = {};
    if (cnss_uuid) {
      data['cnss_uuid'] = cnss_uuid;
    }
    if (cnamgs_uuid) {
      data['cnamgs_uuid'] = cnamgs_uuid;
    }
    if (paid_to_cnss) {
      data['paid_to_cnss'] = paid_to_cnss;
    }
    if (paid_to_cnamgs) {
      data['paid_to_cnamgs'] = paid_to_cnamgs;
    }
    if (total_combined) {
      data['total_combined'] = total_combined;
    }
    data['return_url'] = window.location.href.split('?')[0];
    console.log("DTS Payment Initiate:", data)
    // return

   
    this.ngxUiLoaderService.start();
    this.api.paymentInitiateDts(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.redirectUrl = this.response.url;
            this.router.ngOnDestroy();
            window.location.href = this.redirectUrl;
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 2000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  paymentInitiateCnamgs() {
    var data = {};
    data['uuid'] = this.cnamgsId;
    data['entity_type'] = '4';
    data['total_amount'] = this.cnamgsamount;
    data['return_url'] = window.location.href.split('?')[0];
    console.log("CNAMGS Payment Initiate:", data)
    this.ngxUiLoaderService.start();
    this.api.paymentInitiate(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.redirectUrl = this.response.url;
            this.router.ngOnDestroy();
            window.location.href = this.redirectUrl;
          } else {
            this.snackBar.open(this.response.message, "Ignorer", {
              duration: 2000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  ViewAllLateCnamgsDtsList() {
    console.log("View All CNAMGS DTS List")
    this.showAllCnamgsDtsList = !this.showAllCnamgsDtsList;
  }

  ViewAllLateCnamgsPaymentList() {
    console.log("View All CNAMGS Payment List")
    this.showAllCnamgsPaymentList = !this.showAllCnamgsPaymentList;
  }

  cnamgsReportExpand() {
    this.isOpenCnamgsReport = !this.isOpenCnamgsReport;
  }
  
  cnssReportExpand() {
    this.isOpenCnssReport = !this.isOpenCnssReport;
  }


}
